import React from 'react';
import { BookOpen, Target, HeartHandshake, Shield } from 'lucide-react';
export function WhatYouGetSection() {
  const benefits = [{
    icon: <Target className="w-6 h-6 text-trust" data-id="element-237" />,
    title: 'Límites Claros y Respetados',
    description: 'Aprenderás a establecer reglas sobre el uso del celular que tu adolescente realmente escuchará y respetará, sin necesidad de gritar.'
  }, {
    icon: <HeartHandshake className="w-6 h-6 text-trust" data-id="element-238" />,
    title: 'Recuperar la Conexión',
    description: 'Estrategias prácticas para volver a conversar, reír y compartir momentos en familia sin que una pantalla se interponga.'
  }, {
    icon: <BookOpen className="w-6 h-6 text-trust" data-id="element-239" />,
    title: 'Guiones Exactos',
    description: 'Sabrás exactamente qué decir (y qué no decir) cuando rompan las reglas o cuando necesites que dejen el teléfono.'
  }, {
    icon: <Shield className="w-6 h-6 text-trust" data-id="element-240" />,
    title: 'Paz Mental',
    description: 'La tranquilidad de saber que estás protegiendo su desarrollo y su salud mental, mientras mantienes la armonía en casa.'
  }];
  return <section className="bg-primary py-10 md:py-24 px-4" data-id="element-241">
      <div className="max-w-5xl mx-auto" data-id="element-242">
        <div className="text-center mb-10 md:mb-16" data-id="element-243">
          <h2 className="text-2xl md:text-4xl font-bold text-text-primary mb-3 md:mb-4" data-id="element-244">
            Lo que obtienes hoy con esta guía
          </h2>
          <p className="text-base md:text-lg text-text-secondary max-w-2xl mx-auto" data-id="element-245">
            Un mapa claro y compasivo para transformar la dinámica familiar en
            solo 30 días.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-8" data-id="element-246">
          {benefits.map((benefit, index) => <div key={index} className="bg-alternate p-6 md:p-8 rounded-2xl shadow-sm border border-border" data-id="element-247">
              <div className="w-10 h-10 md:w-12 md:h-12 bg-accent rounded-full flex items-center justify-center mb-4 md:mb-6" data-id="element-248">
                {benefit.icon}
              </div>
              <h3 className="text-lg md:text-xl font-bold text-text-primary mb-2 md:mb-3" data-id="element-249">
                {benefit.title}
              </h3>
              <p className="text-sm md:text-base text-text-secondary leading-relaxed" data-id="element-250">
                {benefit.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}